import { useCallback } from "react";
import { Select } from "antd";
import { OrderStatusTag } from "./order-status-tag";
import { OrderConst } from "states/order/order.models";

interface IOrderStatusSelectorProps {
  orderStatus?: string[];
  onChange?: (orderStatus: string[]) => void;
}
const { Option } = Select;
export const OrderStatusSelector = (props: IOrderStatusSelectorProps) => {
  const { orderStatus, onChange } = props;
  const _handleOnChange = useCallback(
    (value: string[]) => {
      onChange && onChange(value);
    },
    [onChange]
  );
  return (
    <Select
      className="w-100"
      placeholder="Trạng thái"
      onChange={_handleOnChange}
      allowClear
      showSearch={false}
      value={orderStatus ?? []}
      mode="multiple"
    >
      <Option value={OrderConst.status.pending}>
        <OrderStatusTag status={OrderConst.status.pending} />
      </Option>
      <Option value={OrderConst.status.onOrder}>
        <OrderStatusTag status={OrderConst.status.onOrder} />
      </Option>
      <Option value={OrderConst.status.shipping}>
        <OrderStatusTag status={OrderConst.status.shipping} />
      </Option>
      <Option value={OrderConst.status.returning}>
        <OrderStatusTag status={OrderConst.status.returning} />
      </Option>
      <Option value={OrderConst.status.returned}>
        <OrderStatusTag status={OrderConst.status.returned} />
      </Option>
      <Option value={OrderConst.status.received}>
        <OrderStatusTag status={OrderConst.status.received} />
      </Option>
      <Option value={OrderConst.status.completed}>
        <OrderStatusTag status={OrderConst.status.completed} />
      </Option>
      <Option value={OrderConst.status.cancel}>
        <OrderStatusTag status={OrderConst.status.cancel} />
      </Option>
    </Select>
  );
};
